import { useToast } from '@repo/design-system/index'
import { ActivityComponentType } from '@stackflow/react'
import { useEffect, useState } from 'react'
import apis from '../../../modules/apis'
import { useUpcomingsV5 } from '../../../modules/apis/common/user'
import { axiosGet, axiosPost } from '../../../modules/axiosHelper'
import useWebviewNavigation from '../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_upcoming_lessons, s_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import CancelModalBody from '../../new-portal/lessons/upcoming/CancelModalBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface ILessonCancel {
  params: {
    lessonId: string
  }
}

const LessonCancelActivity: ActivityComponentType = ({ params }: ILessonCancel) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { toastSuccess } = useToast()
  const [message, setMessage] = useState(null)
  const [cancelData, setCancelData] = useState(null)
  const [cancelList, setCancelList] = useState(null)
  const [filteredItem, setFilteredItem] = useState(null)
  const { t } = useTranslation()
  const { popBackToRingleApp } = useWebviewNavigation()

  const { data } = useUpcomingsV5()

  const fetchData = async () => {
    const response = await axiosGet(apis.lesson.cancelPolicy(params.lessonId))

    if (response) {
      setCancelList(
        response.cancel_list.map((item, i) => {
          return {
            name: item.title,
            value: item.value,
          }
        })
      )
      setCancelData(response)

      setMessage(response.message)
    }
  }

  useEffect(() => {
    if (data) {
      console.log(data.upcoming_lessons.find((item) => item.id === Number(params.lessonId)))
      setFilteredItem(data.upcoming_lessons.find((item) => item.id === Number(params.lessonId)))
      fetchData()
    }
  }, [data])

  const handleCancelWebview = async (item, reason, reasonDetail) => {
    const payload = {
      cancel_reason_type: reason,
      cancel_reason_text: reasonDetail,
    }
    const response = await axiosPost(apis.lesson.cancel(item.id), payload)
    if (response.success) {
      // await queryClient.invalidateQueries([apis.lessons.upcomingsV5()])
      // await queryClient.invalidateQueries([apis.lessons.upcomingsCount()])

      toastSuccess(t(s_upcoming_lessons.after_tutor_cancel.lesson_canceled))

      setTimeout(async () => {
        popBackToRingleApp()
      }, 3000)
    }
  }

  return (
    <WebviewStackContainer onBack={pop} title={t(n_upcoming_lessons.menu_option5)}>
      <div>
        {filteredItem && message && cancelList && (
          <CancelModalBody
            message={message}
            item={filteredItem}
            cancelList={cancelList}
            handleCancelWebview={handleCancelWebview}
            isWeeklyLessonPackage={cancelData?.is_weekly_lesson_package}
            timeDiff={cancelData?.time_diff}
          />
        )}
      </div>
    </WebviewStackContainer>
  )
}

export default LessonCancelActivity
